export const startVisitorLiveChat = () => {
  window.Intercom('shutdown');
  window.Intercom('boot', {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  });
};
